import ApplicationSerializer from 'admin-panel/serializers/application';

import type DS from 'ember-data'; // eslint-disable-line ember/use-ember-data-rfc-395-imports
import type ModelRegistry from 'ember-data/types/registries/model'; // eslint-disable-line ember/use-ember-data-rfc-395-imports
import type RoomControlTvChannelModel from 'admin-panel/models/room-control/tv-channel';

export default class RoomControlTvChannelSerializer extends ApplicationSerializer {
  serialize<K extends keyof ModelRegistry>(
    snapshot: DS.Snapshot<K>,
    options: { includeId?: boolean }
  ) {
    const json = super.serialize(snapshot, options) as Record<string, unknown>;

    if ('title_translations' in json) {
      // The API treats the `title` value as the English translation.
      // English is always the source of truth here — TV channel names are
      // canonical strings, not locale-specific content.
      json['title'] = (snapshot.record as RoomControlTvChannelModel).title;

      delete json['title_translations'];
    }

    if (snapshot.adapterOptions?.['removeLogo']) {
      // The API requires `logo: null` to remove the logo — setting
      // `logo_uid`/`logo_url` to null has no effect.
      json['logo'] = null;

      delete json['logo_uid'];
      delete json['logo_url'];
    }

    const hotelIds = snapshot.adapterOptions?.['hotelIds'];
    if (hotelIds) {
      json['hotel_ids'] = hotelIds;
    }

    return json;
  }
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'room-control/tv-channel': RoomControlTvChannelSerializer;
  }
}
